module.exports = __webpack_public_path__ + "img/suit-10.e2f9f1d3.png";